module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative"
  }, [_c('div', {
    staticClass: "week-picker__content flex"
  }, [_c('div', {
    staticClass: "content"
  }, _vm._l((_vm.weeks), function(week, index) {
    return _c('div', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip"
      }],
      key: week.serverDate,
      staticClass: "number hint--top",
      class: [{
        'isSelected': week.isSelected
      }, {
        'isCopyWeek': week.isCopyWeek
      }],
      attrs: {
        "aria-label": _vm._f("tooltipDate")(week.date)
      },
      on: {
        "click": function($event) {
          return _vm.toggleWeek(index)
        }
      }
    }, [_c('span', {
      class: {
        'isNow': week.isNow
      }
    }, [_vm._v("\n            " + _vm._s(week.weekNum) + "\n          ")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sortcuts"
  }, [(!_vm.calid) ? _c('select', {
    staticClass: "copy-week-picker-school-year-selector",
    domProps: {
      "value": _vm.activeSchoolYear.id
    },
    on: {
      "change": _vm.setActiveSchoolYear
    }
  }, _vm._l((_vm.activeSchoolYears), function(year) {
    return _c('option', {
      key: year.id,
      domProps: {
        "value": year.id
      }
    }, [_vm._v("\n          " + _vm._s(year.name) + "\n        ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "sortcuts__headline"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.markWeeksFrom')) + "\n            "), _c('div', {
    staticClass: "no-tag",
    class: {
      'tag': !_vm.showStartPasteWeek
    }
  }, [_vm._v("\n              " + _vm._s(_vm._f("week")(_vm.startPasteWeek)) + "\n              "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showStartPasteWeek),
      expression: "!showStartPasteWeek"
    }],
    staticClass: "icon-cross2 pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.eraseStartDate.apply(null, arguments)
      }
    }
  })])])]), _c('li', [_c('span', {
    staticClass: "sortcut__clickable",
    on: {
      "click": _vm.selectAll
    }
  }, [_c('span', {
    staticClass: "bttn width-100 btn-trans"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.allWeeks')) + "\n                ")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "sortcut__clickable",
    on: {
      "click": _vm.selectOddWeeks
    }
  }, [_c('span', {
    staticClass: "bttn width-100 btn-trans"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.oddWeeks')) + "\n               ")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "sortcut__clickable",
    on: {
      "click": _vm.selectEvenWeeks
    }
  }, [_c('span', {
    staticClass: "bttn width-100 btn-trans"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.evenWeeks')) + "\n               ")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "sortcut__clickable",
    on: {
      "click": _vm.removeAllSelectedWeeks
    }
  }, [_c('span', {
    staticClass: "bttn btn-trans width-100 btn-remove"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.unselectAll')) + "\n               ")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4791d929!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Presence/User/WeekPicker.vue
// module id = 1619
// module chunks = 1